import React, {useState} from 'react'
import {getImageTitle} from 'lib/imageUtils'
import SelectablePhotoThumb from 'components/shared/SelectablePhotoThumb'
import PhotoGallery from 'components/shared/PhotoGallery'
import './index.scss'

function reducer(state, action) {
  switch (action.type) {
    case 'markPhoto': {
      return [...state, action.photo]
    }
    case 'unmarkPhoto': {
      return state.filter(photo => photo.id !== action.photo.id)
    }
    default: {
      throw new Error(`Unknown action ${action}`)
    }
  }
}

const SelectPhotoAssets = ({
  product,
  photos,
  minQuantity,
  maxQuantity,
  selectedPhotos,
  onSelection,
  readOnly = false,
}) => {
  const [photoPreviewIndex, setPhotoPreviewIndex] = useState(null)

  const previewPhoto = (index) => setPhotoPreviewIndex(index)
  const closeGallery = () => setPhotoPreviewIndex(null)

  const photoSelectedChanged = (photo, selected) => {
    const type = selected ? 'markPhoto' : 'unmarkPhoto'
    onSelection(reducer(selectedPhotos, {type, photo}))
  }

  const photoIsSelected = (photo) => {
    return !!selectedPhotos.find(p => p.id === photo.id)
  }

  const hasSelectedPhotos = () => {
    const length = selectedPhotos.length
    return (length >= minQuantity) && (!maxQuantity || length <= maxQuantity)
  }

  const titleForPhotoIndex = (index) => {
    return getImageTitle(photos[index].image)
  }

  const photoThumbLabel = (photo) => {
    if (!readOnly && hasSelectedPhotos() && !photoIsSelected(photo) && product.extraAssetUnitPrice) {
      return `Velg (+${product.extraAssetUnitPrice}kr)`
    }
    return null
  }

  const galleryCaptionForPhotoIndex = (index) => {
    if (readOnly) return null
    const photo = photos[index]
    return (
      <div className="selected-photo-assets-gallery-caption">
        <SelectablePhotoThumb.Overlay
          label={photoThumbLabel(photo)}
          selected={photoIsSelected(photo)}
          onChange={(selected) => photoSelectedChanged(photo, selected)}
        />
      </div>
    )
  }

  return (
    <div className="selected-photo-assets">
      <SelectablePhotoThumb.Wrapper>
        {photos.map((photo, i) => (
          <SelectablePhotoThumb
            key={photo.id}
            photo={photo}
            selected={photoIsSelected(photo)}
            label={photoThumbLabel(photo)}
            onChange={(selected) => photoSelectedChanged(photo, selected)}
            onClick={() => previewPhoto(i)}
            title={titleForPhotoIndex(i)}
            isSelectable={!readOnly}
          />
        ))}
      </SelectablePhotoThumb.Wrapper>

      {photoPreviewIndex !== null && (
        <PhotoGallery
          images={photos.map(p => p.image.url)}
          initialImageIndex={photoPreviewIndex}
          onRenderCaption={(i) => galleryCaptionForPhotoIndex(i)}
          onRenderTitle={(i) => titleForPhotoIndex(i)}
          onCloseRequest={closeGallery}
        />
      )}
    </div>
  )
}

export default SelectPhotoAssets
